'use client';

import useBffCatalogProductsQuery from '@/core/queries/bff/catalog/use-bff-catalog-products-query';
import { findCatalogProductByCode } from '@/core/utils/catalog/catalog-lookup';

type UseProductStockResult = {
  hasStock: boolean | undefined;
  isLoading: boolean;
  isFetched: boolean;
};

/** Pass stable BFF catalog product `code` (not the environment-specific numeric id). */
const useProductStock = (
  productCode: string | undefined,
): UseProductStockResult => {
  const { data, isLoading, isFetched } = useBffCatalogProductsQuery();

  const product = findCatalogProductByCode(data?.data, productCode ?? '');
  const hasStock = product?.availability?.delivery.available;

  return {
    hasStock,
    isLoading,
    isFetched,
  };
};

export default useProductStock;
